module.exports = __webpack_public_path__ + "img/normal-buy-hen.ae78c4f6.png";